import { apiService } from "@/lib/fetch-signal-factory";

interface CompanyDomainParams {
  domain: string;
}

interface CompanyDomainResponse {
  id: number;
  name: string;
  companyDomain: string;
  companyLogo: string;
  companyName: string;
  companyLogoName: string;
  companySkin: number;
  companyAccount: string;
  companyPwd: string;
  companyMail: string;
  companyMailPwd: string;
  logo1: string;
  logo2: string;
  logo3: string;
  logo4: string;
  logo5: string;
  logo6: string;
  pcLogo1: string;
  pcLogo2: string;
  pcLogo3: string;
  pcLogo4: string;
  pcLogo5: string;
  pcLogo6: string;
  phoneDomian: string;
  iosDomain: string;
  androidDomain: string;
  status: number;
  isDel: number;
  leverFee: number;
  hyFee: number;
  kjFee: number;
  inviteType: number;
  appStatus: number;
  c2ctxStatus: number;
  c2cczStatus: number;
  pledgeStatus: number;
  pledgeFee: number;
  createTime: string | null;
  updateTime: string | null;
}

  let host = window?.location?.host;
  host = host?.includes("localhost") ? "jiaoyiys.icu" : host;

export const companyDomainService = apiService.create<
  CompanyDomainResponse,
  CompanyDomainParams
>("/api/pc/company/domain", {
    params: {
        domain: host
    }
});
